var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-wd border-input btn-rounded",class:[{' btn-fill':_vm.fill}, _vm.getColor()],attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.execute(_vm.event, _vm.params)}}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2828f74a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Buttons/ButtonRounded.vue
// module id = 6Oeg
// module chunks = 0